export const PRODUCT_NAME = 'packages'
